export function formatCompactCount(value: number | undefined | null): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '0';
  if (Math.abs(n) >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (Math.abs(n) >= 1_000) {
    return `${(n / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return new Intl.NumberFormat('en-US').format(n);
}

export function formatCtrDisplay(rate: number | undefined | null): string {
  if (rate == null || Number.isNaN(rate)) return '0%';
  const n = rate <= 1 && rate >= 0 ? Math.round(rate * 100) : Math.round(rate);
  return `${n}%`;
}
